import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";

import { TAutoLogoutDialogConfig } from "@app/core/auto-logout/components/auto-logout-dialog/auto-logout-dialog.type";

import { AutoLogoutDialogComponent } from "@app/core/auto-logout/components/auto-logout-dialog/auto-logout-dialog.component";

export const AUTO_LOGOUT_DIALOG = (data: TAutoLogoutDialogConfig)
  : MatDialogConfig<TAutoLogoutDialogConfig> => ({
  disableClose: true,
  autoFocus: false,
  maxWidth: "600px",
  data: data
});

export function openAutoLogoutDialog(matDialog: MatDialog, data: TAutoLogoutDialogConfig): MatDialogRef<AutoLogoutDialogComponent, boolean> {
  return matDialog.open<AutoLogoutDialogComponent, TAutoLogoutDialogConfig, boolean>(
    AutoLogoutDialogComponent, AUTO_LOGOUT_DIALOG(data)
  );
}
